const floorList1 = [
    {
        floor: 'b2',
        floorIdx: -2,
        id: 1,
    },
    {
        floor: 'b1',
        floorIdx: -1,
        id: 2,
    },
    {
        floor: '1',
        floorIdx: 1,
        id: 3,
    },
    {
        floor: '2',
        floorIdx: 2,
        id: 4,
    },
    {
        floor: '3',
        floorIdx: 3,
        id: 5,
    },
    {
        floor: '4',
        floorIdx: 4,
        id: 6,
    },
    {
        floor: '5',
        floorIdx: 5,
        id: 7,
    },
]
const floorList2 = [
    {
        floor: 'b2',
        floorIdx: -2,
        id: 8,
    },
    {
        floor: 'b1',
        floorIdx: -1,
        id: 9,
    },
    {
        floor: '1',
        floorIdx: 1,
        id: 10,
    },
    {
        floor: '2',
        floorIdx: 2,
        id: 11,
    },
    {
        floor: '3',
        floorIdx: 3,
        id: 12,
    },
    {
        floor: '4',
        floorIdx: 4,
        id: 13,
    },
    {
        floor: '5',
        floorIdx: 5,
        id: 14,
    },
]
const floorList3 = [
    {
        floor: 'b2',
        floorIdx: -2,
        id: 15,
    },
    {
        floor: 'b1',
        floorIdx: -1,
        id: 16,
    },
    {
        floor: '1',
        floorIdx: 1,
        id: 17,
    },
    {
        floor: '2',
        floorIdx: 2,
        id: 18,
    },
    {
        floor: '3',
        floorIdx: 3,
        id: 19,
    },
    {
        floor: '4',
        floorIdx: 4,
        id: 20,
    },
    {
        floor: '5',
        floorIdx: 5,
        id: 21,
    },
]

export {floorList1, floorList2, floorList3}